import React from 'react';

import {
  FormControl,
  Box,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import SERVICE_TYPES from './serviceTypes';

export default function ServiceTypeField({
  value,
  error,
  setValue,
  setChanged,
  disabled,
  is_public,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    if (event.target.value !== value) {
      setChanged();
    }
    setValue(newValue);
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <InputLabel id='type-label'>Type</InputLabel>
        <Select
          labelId='type-label'
          id='type'
          value={value}
          label='Type'
          aria-describedby='type-helper-text'
          onChange={handleChange}
          disabled={disabled}
          error={Boolean(error)}
        >
          <MenuItem value={SERVICE_TYPES.HTTPS}>HTTPS</MenuItem>
          <MenuItem value={SERVICE_TYPES.HTTP2}>HTTP2</MenuItem>
          {!is_public ? (
            <MenuItem value={SERVICE_TYPES.TCP}>TCP</MenuItem>
          ) : undefined}
          {!is_public ? (
            <MenuItem value={SERVICE_TYPES.UDP}>UDP</MenuItem>
          ) : undefined}
        </Select>
        {error ? (
          <FormHelperText id='type-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='type-helper-text'>
            Select the type of service
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
